import type { TOC } from '@ember/component/template-only';
import { PrismMetricBlock } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface MarketRatesTooltipsTooltipMarketratesHeaderSectionSignature {
  Args: {
    formattedMedian: unknown;
  };
}

const MarketRatesTooltipsTooltipMarketratesHeaderSection = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if @formattedMedian}}
    <div class="tooltip-section">
      <PrismMetricBlock>
        <:value>{{@formattedMedian}}</:value>
        <:label>{{t "rates.median_comp_rate"}}</:label>
      </PrismMetricBlock>
    </div>
  {{/if}}
</template> satisfies TOC<MarketRatesTooltipsTooltipMarketratesHeaderSectionSignature>;

export default MarketRatesTooltipsTooltipMarketratesHeaderSection;
